import React, { useState } from 'react';
import './AppInputField.scss';
import { twMerge } from 'tailwind-merge';
import { isHTML, toInlineHTML } from '../../../utils/helpers';

export const AppInputField = ({
  id,
  inputType = 'text',
  placeholder = '',
  suffix = '',
  prefix = '',
  errorText = '',
  label = '',
  labelTextClassName = '',
  labelSubtext = '',
  isRequired = false,
  icon,
  inputFieldStyles = {},
  isDisabled = false,
  onTextChange = (value) => {},
  onBlur = (e) => {},
  onFocus = (e) => {},
  onMouseDown = (e) => {},
  onMouseUp = (e) => {},
  onPaste,
  value,
  minValue,
  maxValue,
  rows,
  dataPrivate,
  maxLength,
  autoComplete,
}: {
  icon?: Icon,
  id?: string,
  value?: any,
  label?: string,
  labelTextClassName?: string,
  labelSubtext?: string,
  isRequired?: boolean,
  placeholder?: string,
  suffix?: string,
  prefix?: string,
  isDisabled?: boolean,
  inputFieldStyles?: any,
  inputType?: string,
  errorText?: string,
  minValue?: number,
  maxValue?: number,
  onTextChange?: (props: any) => void,
  onBlur?: (props: any) => void,
  onFocus?: (props: any) => void,
  onMouseDown?: (props: any) => void,
  onMouseUp?: (props: any) => void,
  onPaste?: (e: any) => void,
  rows?: number,
  dataPrivate?: boolean,
  maxLength?: number,
  autoComplete?: string,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="w-full flex flex-col">
      {(label || isRequired) && (
        <label
          htmlFor={id}
          className={twMerge(
            'text-xs mb-0.5 text-left  whitespace-nowrap font-medium',
            labelTextClassName
          )}>
          {isRequired && <span className="text-red-500">*</span>}
          {label}
        </label>
      )}
      {labelSubtext &&
        (isHTML(labelSubtext) ? (
          <p
            className="text-2xs mb-0.5 text-left GREY_500-CLR"
            dangerouslySetInnerHTML={{ __html: toInlineHTML(labelSubtext) }}
          />
        ) : (
          <p className="text-2xs mb-0.5 text-left GREY_500-CLR">{labelSubtext}</p>
        ))}

      <div
        className={twMerge('input-wrapper', 'h-fit')}
        style={{
          borderColor: errorText ? '#F04438' : isFocused ? '#3B82F6' : '#E4EAF1',
          ...inputFieldStyles,
          ...(isDisabled ? { backgroundColor: '#E4EAF1' } : {}),
        }}>
        <div className={'input-section '}>
          {icon && <div className="icon">{icon}</div>}
          {prefix && <p className="whitespace-nowrap text-slate-500 mr-2 ">{prefix}</p>}
          {inputType === 'textarea' && (
            <textarea
              className="w-full text-sm resize-none"
              rows={rows ? rows : 5}
              id={id}
              placeholder={placeholder}
              disabled={isDisabled}
              value={value}
              onChange={(e) => {
                onTextChange(e.target.value);
              }}
              onBlur={(e) => {
                setIsFocused(false);
                onBlur(e);
              }}
              onFocus={(e) => {
                setIsFocused(true);
                onFocus(e);
              }}
              onMouseDown={onMouseDown}
              {...(maxLength !== undefined ? { maxLength } : {})}
              {...(dataPrivate && { 'data-private': true })}
              {...(autoComplete !== undefined ? { autoComplete } : {})}
            />
          )}
          {inputType !== 'textarea' && (
            <input
              type={inputType}
              id={id}
              disabled={isDisabled}
              wrap="soft"
              rows="2"
              placeholder={placeholder}
              className={'field'}
              value={value}
              onChange={(e) => {
                const val = e.target.value;
                onTextChange(val);
              }}
              onBlur={(e) => {
                setIsFocused(false);
                onBlur(e);
              }}
              onFocus={(e) => {
                setIsFocused(true);
                onFocus(e);
              }}
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              {...(inputType === 'number' ? { onWheel: (e) => e.currentTarget.blur() } : {})}
              {...(onPaste ? { onPaste } : {})}
              {...(inputType === 'number' && minValue !== undefined ? { min: minValue } : {})}
              {...(inputType === 'number' && maxValue !== undefined ? { max: maxValue } : {})}
              {...(maxLength !== undefined ? { maxLength } : {})}
              {...(dataPrivate && { 'data-private': true })}
              {...(autoComplete !== undefined ? { autoComplete } : {})}
            />
          )}
          {suffix && <p className="whitespace-nowrap text-slate-500">{suffix}</p>}
        </div>
      </div>
      {errorText && <p className="error-text">{errorText}</p>}
    </div>
  );
};
